import { classNames } from '@vkontakte/vkjs';
import { Caption, Footnote, Paragraph } from '@vkontakte/vkui';
import { useCheckDesktop } from '@dui';
import styles from './ChatCellBaseContent.module.css';

interface ChatCellBaseContentProps {
  /** Основной текст сообщения */
  text?: React.ReactNode;
  /** Стиль оформления текста сообщения */
  type?: 'primary' | 'super_like' | 'question' | 'super_message';
  /**
   * Текст перед сообщением.
   * Рекоменуется передавать имя отправителя или тип сообщения
   */
  prefix?: React.ReactNode;
  /** Стиль текста перед сообщением */
  prefixType?: 'default' | 'draft';
  /**
   * Текст после сообщения.
   * Рекомедуется передавать информацию о вложениях для формулировки наличия аттачей
   */
  postfix?: React.ReactNode;
  /**
   * Дополнительный текст.
   * Рекомендуется передавать время отправки
   */
  aside?: React.ReactNode;

  typeTestId?: string;

  textTestId?: string;

  textPrefixTestId?: string;
}

export function ChatCellBaseContent(props: ChatCellBaseContentProps) {
  const {
    text,
    type = 'default',
    aside,
    postfix,
    prefix,
    prefixType = 'default',
    typeTestId,
    textTestId,
    textPrefixTestId,
  } = props;

  const isDesktop = useCheckDesktop();
  const WrapperText = isDesktop ? Footnote : Paragraph;
  const WrapperAside = isDesktop ? Footnote : Caption;

  return (
    <div
      data-testid={typeTestId}
      className={classNames(styles.root, styles[`root__type_${type}`], styles[`root__prefix_type_${prefixType}`])}
    >
      <WrapperText className={styles.in}>
        {prefix && (
          <span data-testid={textPrefixTestId} className={styles.prefix}>
            {prefix}
          </span>
        )}
        {text && <span data-testid={textTestId}>{text}</span>}
        {postfix && <span className={styles.postfix}>{postfix}</span>}
      </WrapperText>
      {aside && <WrapperAside className={styles.aside}>&middot;&nbsp;{aside}</WrapperAside>}
    </div>
  );
}
